export const getNameFormTextFormat = (text) => {
  const words = text.split(" ");
  let formatedText = "";
  words.forEach((w, i) => {
    if (i > 0) formatedText = formatedText + " ";
    if (w === w.toUpperCase()) {
      let newFormat = w.toLowerCase();
      formatedText =
        formatedText + newFormat.charAt(0).toUpperCase() + newFormat.slice(1);
    } else {
      formatedText = formatedText + w.charAt(0).toUpperCase() + w.slice(1);
    }
  });
  return formatedText;
};